/* eslint-disable no-param-reassign */
import type { Editor } from 'slate'

export function resetEditor(editor: Editor): void {
  // Taken from https://stackoverflow.com/questions/74101405/how-to-clear-all-text-in-slate-js-editor
  const point = { path: [0, 0], offset: 0 }
  editor.selection = { anchor: point, focus: point }
  editor.history = { redos: [], undos: [] }
  editor.children = [
    {
      type: 'paragraph',
      children: [{ text: '' }],
    },
  ]
}
